import { isValidBusinessObject, isVOBofType, ValidBusinessObject } from '@iotv/iotv-v3-types'
import { DeviceConfigProps, IDeviceConfig } from './DeviceConfig'
import { BroadcastData, GenerateDeviceControlTransactionRequest } from './generateDeviceControlTransaction'

export type MultipleDeviceControlTransactionRequest = {
  broadcastData?: BroadcastData
  devices: GenerateDeviceControlTransactionRequest['device'][]
} & Omit<GenerateDeviceControlTransactionRequest, 'device'>

// misleadingly named, will be removed
export const isDeviceContext = (x: any): x is DeviceConfigProps & ValidBusinessObject => {
  const c = x as DeviceConfigProps & ValidBusinessObject

  return isVOBofType('DeviceConfig', c)
}

export const isDeviceConfig = (x: any): x is DeviceConfigProps & ValidBusinessObject => {
  const c = x as IDeviceConfig & ValidBusinessObject

  return !!c && !!c.reported && !!c.requested && c.type === 'DeviceConfig'
}
